import { ChangeEvent, useState, useEffect, FC } from "react"
import s from "./UpdateStoks.module.css"
import { useAppDispatch, useAppSelector } from "../../../app/hooks"
import { Modal } from "../../../features/Modal/Modal"
import { selectOrdersStore } from "../../../app/reducers/ordersReducer"
import { StatusInfo } from "../../UpdateStoksIcon/StatusInfo/StatusInfo"
import {
  deleteSamsonWbRecode,
  samsonWbUpdateStocks,
  selectUpdateStocksSamsonStore,
  updateSamsonState,
  uploadSamsonWbRecode,
} from "../../../app/reducers/updateStocksSamson"
import { TipSamson } from "./wb/tip"
import { downloadSamsonRecode, parseSamsonRecode } from "./wb/recode"
import { LogModal } from "../../LogModal/LogModal"
import { getWbSamsonLogData } from "../helpers"
import { LogButton } from "../../LogButton/LogButton"
import { Tabs } from "../../Tabs/Tabs"
import { useNavigateSubTab } from "../../../utils/hooks/useNavigateTab"
import { UpdateWbStocksTab } from "./wb/UpdateWbStocksTabContent"
import {
  selectActiveShops,
  SHOP_IDENT,
} from "../../../app/reducers/settingsReducer"
import { TabContent } from "../../Tab/TabContent"
import { UpdateYaStocksTab } from "./ya/UpdateYaStocksTabContent"
import { WBTokenGuard } from "../../WBTokenGuard/WBTokenGuard"

export const UpdateStocksSamson: FC = () => {
  const dispatch = useAppDispatch()
  useEffect(() => {
    dispatch(updateSamsonState())
  }, [dispatch])

  const [activeSubTab, navigate] = useNavigateSubTab()
  const activeShops = useAppSelector(selectActiveShops)
  const updateStoksStore = useAppSelector(selectUpdateStocksSamsonStore)
  const ordersStore = useAppSelector(selectOrdersStore)
  const { wildberries, ya } = updateStoksStore || {}
  const { storages, yandexCampaigns } = ordersStore

  const tabs: JSX.Element[] = []
  activeShops.includes(SHOP_IDENT.SAMSON) &&
    tabs.push(
      <TabContent name="wildberries" ident={"wildberries"} key={"wildberries"}>
        <WBTokenGuard>
          <UpdateWbStocksTab
            updateStoksState={wildberries}
            storages={storages}
          />
        </WBTokenGuard>
      </TabContent>,
    )
  activeShops.includes(SHOP_IDENT.SAMSON_YANDEX) &&
    tabs.push(
      <TabContent name="yandex" ident={"yandex"} key={"yandex"}>
        <UpdateYaStocksTab updateStoksState={ya} storages={yandexCampaigns} />
      </TabContent>,
    )
  return (
    <div className={s.updateStoksWrapper}>
      <h5>Обновление остатков и цен Самсон ОПТ</h5>
      <Tabs onChange={navigate} activeTabIdent={activeSubTab}>
        {tabs}
      </Tabs>
    </div>
  )
}
